export default function formatCompactNumber(
  number: number | string,
  translations: { [key: string]: string },
) {
  if (number === null || number === undefined) return '';
  if (Number(number) >= 1000 && Number(number) < 1_000_000) {
    return `${(Number(number) / 1000).toFixed(1).replace(/\.0$/, '')}${translations.thousands} `;
  }
  if (Number(number) >= 1_000_000 && Number(number) < 1_000_000_000) {
    return `${(Number(number) / 1_000_000).toFixed(1).replace(/\.0$/, '')}${translations.millions} `;
  }
  if (Number(number) >= 1_000_000_000 && Number(number) < 1_000_000_000_000) {
    return `${(Number(number) / 1_000_000_000).toFixed(1).replace(/\.0$/, '')}${translations.billions} `;
  }

  return number.toString();
}
